import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../../../../../services/payment.service';

@Component({
  selector: 'app-stripe-connect-callback',
  templateUrl: './stripe-connect-callback.component.html',
  styleUrls: ['./stripe-connect-callback.component.scss'],
})
export class StripeConnectCallbackComponent implements OnInit {
  public broadcastChannel = new BroadcastChannel('STRIPE_CONNECT_CHANNEL');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public paymentService: PaymentService,
  ) {}

  ngOnInit() {
    let PartnerID = localStorage.getItem('StripePartnerID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        PartnerID: parseInt(PartnerID),
        Code: params['code'],
      };
      this.paymentService.linkStripeAccountToPartner(data).subscribe(
        (result) => {
          console.log(result);
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
